import { Grid, Stack, Theme, Typography, useTheme } from '@mui/material';
import { ClaimActivityEntry } from '../../../types/type';

interface ClaimActivityInfo {
  activities: ClaimActivityEntry[];
}

const circleStyle = {
  height: '39px',
  width: '39px',
  backgroundColor: '#fff',
  borderRadius: '50%',
  border: '1px solid black',
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  justifyContent: 'center',
};

export default function ClaimActivityCard(props: ClaimActivityInfo) {
  const theme: Theme = useTheme();

  if (!props.activities || props.activities.length === 0) {
    return null;
  }

  return (
    <Stack sx={{ width: '100%' }}>
      <Typography sx={theme.custom.styles.titleType2}>Claim Activity</Typography>
      <Grid item xs={12}>
        {theme.custom.styles.showUnderlinedClaimActivityHeader && (
          <hr
            style={{
              border: theme.custom.styles.hrStyle,
              width: '100%',
            }}
          ></hr>
        )}
      </Grid>
      {props.activities.map((activity, index) => (
        <Stack direction="row" sx={{ marginTop: '1rem' }} key={index}>
          <span style={circleStyle}>
            <Typography
              sx={{
                ...theme.custom.styles.monthShortNameFont,
              }}
            >
              {getMonthAbbr(activity.date)}
            </Typography>
            <Typography
              sx={{
                ...theme.custom.styles.claimSummaryDateFont,
                marginTop: '-0.2rem',
              }}
            >
              {getDayFromFormattedDate(activity.date)}
            </Typography>
          </span>
          <Typography
            sx={{
              ...theme.custom.styles.primaryDescription,
              m: '0.6rem',
            }}
          >
            {activity.message}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}

function getMonthAbbr(formattedDate: string): string {
  if (!formattedDate) return '';
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const parts = formattedDate.split('/');
  if (parts.length < 2) return '';
  const monthIndex = parseInt(parts[0], 10) - 1;
  return months[monthIndex] || '';
}

function getDayFromFormattedDate(formattedDate: string): string {
  if (!formattedDate) return '';
  const parts = formattedDate.split('/');
  if (parts.length < 2) return '';
  return parts[1];
}
